<i *ngIf="isSuppressed" class="fas fa-star suppressed-value-flag" aria-hidden="true"
  ngbTooltip="Value suppressed due to identifiability concerns" placement="top" container="body"></i>
<span *ngIf="isSuppressed" class="visually-hidden">, value suppressed due to identifiability concerns</span>
